import React from "react";

export const handleTouchEvents = (
  startY: number | null,
  setStartY: React.Dispatch<React.SetStateAction<number | null>>,
  startX: number | null,
  setStartX: React.Dispatch<React.SetStateAction<number | null>>,
  setCurrentY: React.Dispatch<React.SetStateAction<number>>,
  setIsDragging: React.Dispatch<React.SetStateAction<boolean>>,
  onTouchEnd: () => void
) => {
  const handleTouchStart = (e: React.TouchEvent | React.MouseEvent) => {
    const touchY =
      e.type === "touchstart"
        ? (e as React.TouchEvent).touches[0].clientY
        : (e as React.MouseEvent).clientY;
    const touchX =
      e.type === "touchstart"
        ? (e as React.TouchEvent).touches[0].clientX
        : (e as React.MouseEvent).clientX;
    setStartY(touchY);
    setStartX(touchX);
    setIsDragging(false);
  };

  const handleTouchMove = (e: React.TouchEvent | React.MouseEvent) => {
    if (!startY || !startX) return;
    const touchY =
      e.type === "touchmove"
        ? (e as React.TouchEvent).touches[0].clientY
        : (e as React.MouseEvent).clientY;
    const touchX =
      e.type === "touchmove"
        ? (e as React.TouchEvent).touches[0].clientX
        : (e as React.MouseEvent).clientX;
    const distanceY = startY - touchY;
    const distanceX = startX - touchX;

    if (Math.abs(distanceX) < Math.abs(distanceY)) {
      setIsDragging(true);
      setCurrentY(distanceY);
    } else {
      setIsDragging(false);
      setCurrentY(0);
    }
  };

  const handleTouchEnd = () => {
    if (startY) {
      onTouchEnd();
    }
    setStartY(null);
    setStartX(null);
    setCurrentY(0);

    setTimeout(() => {
      setIsDragging(false);
    }, 200);
  };

  return { handleTouchStart, handleTouchMove, handleTouchEnd };
};
